import { render, staticRenderFns } from "./robotView3.vue?vue&type=template&id=2db89c4c&scoped=true"
import script from "./robotView3.vue?vue&type=script&lang=js"
export * from "./robotView3.vue?vue&type=script&lang=js"
import style0 from "./robotView3.vue?vue&type=style&index=0&id=2db89c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db89c4c",
  null
  
)

export default component.exports